import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

/**
 * ヘッダー。ブランドはいつも GenDan のトップ（`/`）へ。名前は **どのページでもフルネーム**
 * （Generative AI Shindan）で出す。略称の GenDan とチーム名はフッター（AppFooter.tsx）に集めた。
 *
 * 右側はログイン（doc/AUTH.md §5）。診断そのものはログインなしで最後まで受けられる。
 * ログインすると、作った診断に絵が付き（1 日 3 回まで）、自分の診断を管理できる。
 */
export function AppHeader() {
  return (
    <header className="header">
      <Link className="header__brand" to="/">Generative AI Shindan</Link>
      <nav className="header__nav">
        <Link className="header__link header__link--help" to="/help">ヘルプ</Link>
        <AuthMenu />
      </nav>
    </header>
  );
}

function AuthMenu() {
  const { ready, user, isAdmin, enabled, busy, requestSignIn, signOut } = useAuth();

  if (!enabled) {
    return <span className="header__auth-note" title="VITE_FIREBASE_* が未設定です">ログイン準備中</span>;
  }
  // 状態が決まるまではボタンを出さない（押した直後に消えるのを避ける）
  if (!ready) return <span className="header__auth-note" aria-hidden="true" />;

  // 失敗したときの言い方はダイアログ側が受け持つ（ここはボタンだけ）
  if (!user) {
    return (
      <span className="header__auth">
        <button className="button button--ghost button--small" type="button" onClick={() => void requestSignIn()} disabled={busy}>
          {busy ? 'ログイン中…' : 'ログイン'}
        </button>
      </span>
    );
  }

  return (
    <span className="header__auth">
      <Link className="header__link" to="/me">自分のページ</Link>
      {isAdmin && <Link className="header__link header__link--admin" to="/admin">管理</Link>}
      <button className="button button--ghost button--small" type="button" onClick={() => void signOut()} disabled={busy}>
        ログアウト
      </button>
    </span>
  );
}
